import { render, staticRenderFns } from "./commercialCollege.vue?vue&type=template&id=08cc118b&scoped=true"
import script from "./commercialCollege.vue?vue&type=script&lang=ts"
export * from "./commercialCollege.vue?vue&type=script&lang=ts"
import style0 from "./commercialCollege.vue?vue&type=style&index=0&id=08cc118b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cc118b",
  null
  
)

export default component.exports